import React, { useContext } from 'react';
import StyledButton from './StyledButton';
import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import SectionContentGroupContext from '../../../../Section/SectionContentGroupContext';

type InnerLinkButtonProps = {
  href: string;
  children: React.ReactNode;
};

const InnerLinkButton = ({ href, children }: InnerLinkButtonProps) => {
  const sectionContentGroup = useContext(SectionContentGroupContext);

  return (
    <StyledButton
      fullWidth={sectionContentGroup === ContentGroupType.RIGHT}
      component="a"
      target="_blank"
      href={href}
    >
      {children}
    </StyledButton>
  );
};

export default InnerLinkButton;
